export default "__VITE_ASSET__6672fd4b__"